export interface UpdateToastProps {
  updateAvailable: boolean;
  onApplyUpdate: () => void;
}

export function UpdateToast({ updateAvailable, onApplyUpdate }: UpdateToastProps) {
  if (!updateAvailable) return null;

  return (
    <div
      data-testid="update-toast"
      role="alert"
      style={{
        position: 'fixed',
        bottom: 80,
        right: 16,
        background: '#6366f1',
        color: '#fff',
        padding: '12px 20px',
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        zIndex: 9999,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      }}
    >
      <span>Update available!</span>
      <button
        data-testid="apply-update"
        onClick={onApplyUpdate}
        style={{
          background: '#fff',
          color: '#6366f1',
          border: 'none',
          padding: '4px 12px',
          borderRadius: 4,
          cursor: 'pointer',
          fontWeight: 600,
        }}
      >
        Refresh
      </button>
    </div>
  );
}
